<div id="mauticform_wrapper_passo4docandidato2" class="mauticform_wrapper">
    <form autocomplete="false" role="form" method="post" action="{{formApiUrl}}?formId=19"
        id="mauticform_passo4docandidato2" data-mautic-form="passo4docandidato2" enctype="multipart/form-data" #form>
        <div class="mauticform-error" id="mauticform_passo4docandidato2_error"></div>
        <div class="mauticform-message" id="mauticform_passo4docandidato2_message"></div>
        <div class="mauticform-innerform">

            <div class="mauticform-page-wrapper mauticform-page-1" data-mautic-form-page="1">

                <div id="mauticform_passo4docandidato2_concluido"
                    class="mauticform-row mauticform-text mauticform-field-1">
                    <input id="mauticform_input_passo4docandidato2_concluido" name="mauticform[concluido]" value="true"
                        class="mauticform-input" type="text">
                </div>

                <!--<div id="mauticform_passo4docandidato2_submit" class="mauticform-row mauticform-button-wrapper mauticform-field-2">
                    <button type="submit" name="mauticform[submit]" id="mauticform_input_passo4docandidato2_submit" value="true" class="mauticform-button btn btn-default">Enviar</button>
                </div>-->

                <div id="mauticform_passo4docandidato2_email"
                    class="mauticform-row mauticform-email mauticform-field-2">
                    <input id="mauticform_input_passo4docandidato2_email" name="mauticform[email]"
                        [value]="formData.email" class="mauticform-input" type="email">
                </div>

            </div>

        </div>

        <input type="hidden" name="mauticform[formId]" id="mauticform_passo4docandidato2_id" value="19">
        <input type="hidden" name="mauticform[return]" id="mauticform_passo4docandidato2_return" value="">
        <input type="hidden" name="mauticform[formName]" id="mauticform_passo4docandidato2_name"
            value="passo4docandidato2">

    </form>
</div>